<div class="container-fluid p-0">
  <div class="tab-description">
    Create and manage pages to structure how questions are shown to users during the conversation.
  </div>
    <!-- Action Bar -->
  <div class="action-bar">
    <div class="left-section">
      <!-- Device Selector -->
      <div class="device-selector-container" *ngIf="disableCopy !== true">
        <button 
          class="device-selector-button" 
          [class.open]="showDeviceDropdown"
          (click)="toggleDeviceDropdown()">
          <svg class="device-icon">
            <use [attr.xlink:href]="'./assets/images/icons.svg#' + selectedDevice.toLowerCase()"></use>
          </svg>
          {{ capitalize(selectedDevice) }}
          <svg class="chevron-down">
            <use [attr.xlink:href]="'./assets/images/icons.svg#chevron-down'"></use>
          </svg>
        </button>
        
        <div class="device-dropdown" *ngIf="showDeviceDropdown">
          <ng-container *ngFor="let device of devices">
            <div 
              class="device-option" 
              *ngIf="selectedDevice != device"
              [class.selected]="device === selectedDevice"
              (click)="selectDevice(device)">
              <svg class="device-icon">
                <use [attr.xlink:href]="'./assets/images/icons.svg#' + device.toLowerCase()"></use>
              </svg>
              {{ capitalize(device) }}
            </div>
          </ng-container>
        </div>
      </div>
      
      <!-- New Button -->
      <button class="new-button"  [disabled]="loading || !isUserHasWriteAccess" (click)="openPageModal(pageModal)">
        Create New Page
      </button>
    </div>
    
    <div class="center-section">
      <!-- Apply to Section -->
      <div class="apply-to-section" *ngIf="disableCopy !== true">
        <span class="apply-to-label">Apply to</span>
        <div class="apply-to-buttons">
          <ng-container *ngFor="let device of devices">
            <button 
              *ngIf="selectedDevice != device"
              [disabled]="filteredPages.length === 0 || !isUserHasWriteAccess"
              class="apply-to-button" 
              (click)="copyDisplayConfiguration(selectedDevice, device)">
              <svg class="device-icon">
                <use [attr.xlink:href]="'./assets/images/icons.svg#' + device.toLowerCase()"></use>
              </svg>
              {{ capitalize(device) }}
            </button>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="right-section">
      <!--Total Pages -->
      <div class="total-pages">
        <span>Total Pages: {{filteredPages.length}}</span>
      </div>
      
      <!-- Search Box -->
      <div class="search-box">
        <div class="input-group">
          <span class="input-group-text bg-white pr-0">
            <svg class="icon-set">
              <use [attr.xlink:href]="'./assets/images/icons.svg#search'"></use>
            </svg>
          </span>
          <input 
            type="text" 
            class="form-control border-start-0 border-right" 
            placeholder="Search a page" 
            [(ngModel)]="searchText"
            (ngModelChange)="filterPages()"
            [disabled]="!pages || pages.length === 0">
        </div>
      </div>
      
      <!-- Save Button -->
      <div class="header-button">
        <button class="btn-save"  [disabled]="!isSaveEnabled || !isUserHasWriteAccess" [class.disabled]="!isSaveEnabled || !isUserHasWriteAccess" (click)="saveConversation()"><span class="save-btn-new">{{buttonLabel}}</span></button>
      </div>
    </div>
  </div>
  
  <!-- Loading State -->
  <div class="text-center py-5" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading pages...</p>
  </div>
  
  <!-- Empty State -->
  <div class="empty-state" *ngIf="!loading && (!pages || filteredPages.length === 0)">
    <div class="text-center py-5">
      <h5>No Pages Available {{ disableCopy ? '' : ' for ' + capitalize(selectedDevice)}}</h5>
      <p class="text-muted">No pages available. Click on "Create new page" to add your first page</p>
    </div>
  </div>
  
  <!-- Pages List -->
  <div class="pages-container" *ngIf="!loading && filteredPages && filteredPages.length > 0" 
       cdkDropList 
       [cdkDropListData]="filteredPages"
       [cdkDropListDisabled]="!isUserHasWriteAccess"
       (cdkDropListDropped)="dropPage($event)">
    
    <div class="page-card" *ngFor="let page of filteredPages; let i = index" cdkDrag [cdkDragData]="page">
      <!-- Drag Handle -->
      <div class="drag-handle" cdkDragHandle title="Drag to reorder">
        <svg class="icon-set">
          <use [attr.xlink:href]="'./assets/images/icons.svg#reorder'"></use>
        </svg>
      </div>
      
      <!-- Page Content -->
      <div class="page-content">
        <div class="page-title">{{ page.page_title }}</div>
        <div class="page-metadata">
          <div class="page-fields-count text-muted" *ngIf="page.fields && page.fields.length > 0">
            {{ page.fields.length }} interactions
          </div>
        </div>
      </div>
      
      <!-- Actions -->
      <div class="page-actions">
        <div class="badges mt-1" *ngIf="page.is_last_page || page.expired_flows || page.archive_flows">
          <span *ngIf="page.is_last_page" class="badge bg-success me-1">Thank You page</span>
          <span *ngIf="page.expired_flows" class="badge bg-warning me-1">Request Link Expired page</span>
          <span *ngIf="page.archive_flows" class="badge bg-info me-1">Response already submitted page</span>
        </div>
        <button class="btn action-btn" (click)="openPageModal(pageModal, page.id, i)"
                [attr.aria-label]="'Edit page: ' + page.page_title"
                title="Edit page">
          <svg class="icon-set">
            <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
          </svg>
        </button>
        
        <button class="btn action-btn" [disabled]="!isUserHasWriteAccess" (click)="deletePage(page)"
                [attr.aria-label]="'Delete page: ' + page.page_title"
                title="Delete page">
          <svg class="icon-set">
            <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Page Modal Template -->
<!-- Page Edit Modal -->
<div class="page-edit-modal" *ngIf="showPageEditModal && selectedPage">
  <div class="modal-overlay" (click)="closePageEditModal()"></div>
  <div class="modal-container">
    <div class="modal-header">
      <div class="section-title">Page</div>
      <button class="close-button" (click)="closePageEditModal()">
        <svg class="icon-set">
          <use [attr.xlink:href]="'./assets/images/icons.svg#close'"></use>
        </svg>
      </button>
    </div>
        
    <div class="modal-content">
      <div class="page-edit-form">
        <div class="form-group">
          <label for="pageName"><div class="section-title">Page Name</div></label>
          <div class="page-name-search-row">
            <input type="text" id="pageName" class="form-control page-name-input" [disabled]="!isUserHasWriteAccess" [(ngModel)]="selectedPage.page_title" placeholder="Enter page name">
          </div>
        </div>
        
        <div class="question-management">
          
          <div>
            <div class="all-question">
              <div class="section-title" >All Questions 
                <span class="add-all" *ngIf="areAllQuestionsSelected('Add all')"  (click)="toggleAllQuestions('Add all')">Add All</span>
                <span class="add-all disabled" *ngIf="!areAllQuestionsSelected('Add all')">Add All</span>
              </div>
              <div class="questions-list">
                <div class="question-item" *ngFor="let question of filteredAllQuestions" >
                  <div class="question-content">
                    <div class="question-text" title="{{question.text}}">{{ question.text }}</div>
                  </div>
                  <div>
                    <span class="question-type-badge badge-primary-rating" *ngIf="question.field_id.toString() == 'primary_rating'">Primary Rating</span>
                    <span class="question-type-badge badge-primary-comment" *ngIf="question.field_id.toString() == 'comments'">Primary Comment</span>
                  </div>
                  <label class="checkbox-container" (click)="$event.stopPropagation()">
                    <button class="question-add" [disabled]="!isUserHasWriteAccess" (click)="toggleQuestionSelection(question)">
                      <svg class="icon-set">
                        <use [attr.xlink:href]="'./assets/images/icons.svg#chevron-double-right'"></use>
                      </svg>
                    </button>
                  </label>
                </div>
                <div class="empty-list-message" *ngIf="filteredAllQuestions.length === 0">
                  No Questions are left to be configured.
                </div>
              </div>
            </div>
            <div class="question-reorder">
              <div class="section-title">Current Page Questions <small *ngIf="currentPageQuestions.length > 0">, {{ currentPageQuestions.length }} selected</small>
                <span class="add-all remove-all" *ngIf="areAllQuestionsSelected('Remove all')" (click)="toggleAllQuestions('Remove all')">Remove All</span>
                <span class="add-all remove-all disabled" *ngIf="!areAllQuestionsSelected('Remove all')">Remove All</span>
              </div>
              <div *ngIf="currentPageQuestions.length > 0">
                <div class="selected-questions-list" cdkDropList 
                    [cdkDropListDisabled]="!isUserHasWriteAccess"
                    [cdkDropListData]="currentPageQuestions"
                    (cdkDropListDropped)="dropQuestion($event)">
                  <div class="selected-question-item" *ngFor="let question of currentPageQuestions" cdkDrag>
                    <div class="question-drag-handle" cdkDragHandle>
                      <svg class="icon-set">
                        <use [attr.xlink:href]="'./assets/images/icons.svg#reorder'"></use>
                      </svg>
                    </div>
                    <div class="question-content">
                      <div class="question-text" title="{{question.text}}">{{question.text}}</div>
                    </div>
                    <div>
                      <span class="question-type-badge badge-primary-rating" *ngIf="question.field_id.toString() == 'primary_rating'">Primary Rating</span>
                      <span class="question-type-badge badge-primary-comment" *ngIf="question.field_id.toString() == 'comments'">Primary Comment</span>
                    </div>
                    <label class="checkbox-container" (click)="$event.stopPropagation()">
                      <button class="question-remove" [disabled]="!isUserHasWriteAccess" (click)="removeQuestionFromPage(question)">
                        <svg class="icon-set">
                          <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
                        </svg>
                      </button>
                    </label>
                  </div>
                </div>
              </div>
              <div *ngIf="currentPageQuestions.length == 0">
                <div class="selected-questions-list">
                  <div class="no-question-selected-message">Please add at least one question to the page</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="page-edit-form">
        <div class="section-title">Options</div>
        <div class="advanced-options">
          <div class="option-row">
            <div class="option-control">
              <label class="checkbox-container">
                <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="selectedPage.calculate_for_progress">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="option-label">Include page in progress bar calculation</div>
          </div>
          
          <div class="option-row">
            <div class="option-control">
              <label class="checkbox-container">
                <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="selectedPage.isShowProgressBar">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="option-label">Show/hide conversation progress bar</div>
          </div>
          
          <div class="option-row">
            <div class="option-control">
              <label class="checkbox-container">
                <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="selectedPage.save_on_submit">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="option-label">Save on Next Button</div>
          </div>
          
          <div class="option-row">
            <div class="option-control">
              <label class="checkbox-container">
                <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="selectedPage.enable_auto_scroll">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="option-label">Enable Auto Scroll on this page</div>
          </div>
          
          <div class="option-row">
            <div class="option-control">
              <label class="checkbox-container">
                <input type="checkbox" [disabled]="!isUserHasWriteAccess" [(ngModel)]="selectedPage.is_rating_page">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="option-label">Show Next / Submit Button</div>

            <div class="option-control mr-60" *ngIf="selectedPage.is_rating_page">
              <div class="option-label">Next Button Text</div>
              <input type="text" class="form-control small-control" [disabled]="!isUserHasWriteAccess" [(ngModel)]="default_rating_button_label" (change)="onRatingButtonLabelChange($event)" placeholder="Type Next Button text(e.g. Submit)">
            </div>

            <div class="option-control" *ngIf="selectedPage.is_rating_page">
              <div class="option-label">Back Button Text</div>
              <input type="text" class="form-control small-control" [disabled]="!isUserHasWriteAccess" [(ngModel)]="default_rating_back_button_label" (change)="onRatingBackButtonLabelChange($event)" placeholder="Type Back Button text">
            </div>

          </div>
          
          <div class="option-row">
            <div class="option-control">
              <label class="checkbox-container">
                <input type="checkbox" 
                       [disabled]="!isUserHasWriteAccess"
                       [checked]="selectedPage && selectedPage.is_last_page || false" 
                       (change)="onThankYouPageChange($event)">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="option-label">Make this page as Thank you Page</div>
          </div>
          
          <div class="option-row">
            <div class="option-control">
              <label class="checkbox-container">
                <input type="checkbox" [disabled]="!isUserHasWriteAccess" [checked]="selectedPage.expired_flows" (change)="onLinkExpiredChange($event)">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="option-label">Make this page as Request Link Expired Page</div>
          </div>
          
          <div class="option-row">
            <div class="option-control">
              <label class="checkbox-container">
                <input type="checkbox" [disabled]="!isUserHasWriteAccess" [checked]="selectedPage.archive_flows" (change)="onResponseSubmittedChange($event)">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="option-label">Make this page as Response Already Submitted Page</div>
          </div>

          <div class="option-row">
            <div class="option-control">
              <label class="checkbox-container">
                <input type="checkbox" 
                       [disabled]="!isUserHasWriteAccess"
                       [ngModel]="selectedPage && selectedPage.enable_suffle || false" 
                       (ngModelChange)="selectedPage && (selectedPage.enable_suffle = $event)">
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="option-label">Consider this page for Page Shuffling</div>
          </div>

        </div>
      </div>
    </div>
    
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closePageEditModal()">Cancel</button>
      <button class="btn-save" [disabled]="!isSaveEnabled || !isUserHasWriteAccess" [class.disabled]="!isSaveEnabled || !isUserHasWriteAccess" (click)="savePageEdit()">{{buttonLabel}}</button>
    </div>
  </div>
</div>
